import { render } from "./FormTip.vue?vue&type=template&id=7da68be3"
import script from "./FormTip.vue?vue&type=script&lang=js"
export * from "./FormTip.vue?vue&type=script&lang=js"

import "./FormTip.vue?vue&type=style&index=0&id=7da68be3&lang=css"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__